export default __webpack_public_path__ + "6e07d5227764c66138d83c57177ba713.svg";